interface PlayModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

export default function PlayModal({ open, title, onClose }: PlayModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-primary-950/70" onClick={onClose} aria-hidden="true" />
      <div className="relative w-full max-w-md rounded-xl border border-background-200 bg-background-50 p-6 text-center">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-2xl text-accent-600">
          <i className="ri-play-circle-line" />
        </span>
        <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">播放演示</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          《{title}》播放为前端演示功能，暂未接入真实播放接口，敬请期待完整上线的观看服务。
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-600 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-700"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}